import { OperationType } from '../../utils/settings';

const initialState = {
  addedUserList: [],
  booking_details: {},
  booking_editorder_details: {},

  //Secondary Order , for temporary basis
  isSecondaryOrder: false,

  // FMCG
  isFmcgFlow: false,
  selectedStp: {},
  stpProds: [],

  // PaintFlow
  isPaintFlow: false,

  // industrySelection
  subIndustryType: null,

  // distributor
  seller_id: null,

  company_esi_id: null,
  // Supplier for secondary order eg: distributor Id
  supplier_id: null,

  // No downward chain
  noDownwardChain: false,
  isDeliveryAddressSameAsConsigneeAddress: true,
  selectedCompany: null,
  
};

const bcmOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_BCM_ORDER': {
      return {
        ...initialState,
        stpProds: [],
      };
    }
    case 'SET_SUB_INDUSTRY_TYPE': {
      return { ...state, subIndustryType: action.data };
    }
    case 'SET_SELECTED_COMPANY':
      return { ...state, selectedCompany: action.payload,};
    case 'CLEAR_SELECTED_COMPANY':
      return { ...state,selectedCompany: null,};
    case 'SET_SELLER_ID': {
      return { ...state, seller_id: action.data };
    }
    case 'SET_COMPANY_ESI_ID': {
      return { ...state, company_esi_id: action.data };
    }
    case 'SET_SUPPLIER_ID': {
      return { ...state, supplier_id: action.data };
    }
    case 'SET_NO_DOWNWARD_CHAIN': {
      return { ...state, noDownwardChain: action.data };
    }
    case 'IS_SECONDARY_ORDER': {
      return { ...state, isSecondaryOrder: action.data };
    }
    case 'SET_IS_PAINT_FLOW': {
      return { ...state, isPaintFlow: action.data };
    }
    case 'SET_IS_FMCG_FLOW': {
      return { ...state, isFmcgFlow: action.data };
    }
    case 'SET_SELECTED_STP': {
      return { ...state, selectedStp: action.data };
    }

    case 'SET_DELIVERY_ADDRESS_SAME_AS_CONSIGNEE_ADDRESS': {
      return { ...state, isDeliveryAddressSameAsConsigneeAddress: action.data };
    }
    // Prods for STP
    case 'ADD_PROD_FOR_STP': {
      let prodList = state?.stpProds || [];

      // check if prod exist in prodList or add
      const index = prodList.findIndex(
        (vv) => vv.product_id === action.data.product_id,
      );
      if (index === -1) {
        prodList.push(action.data);
      }
      return { ...state, stpProds: prodList };
    }

    case 'REMOVE_PROD_FOR_STP': {
      let prodList = state?.stpProds || [];
      prodList = prodList.filter(
        (vv) => vv.product_id !== action.data.product_id,
      );
      return { ...state, stpProds: prodList };
    }

    case 'INCREMENT_PRODUCT_QTY_OF_STP': {
      return {
        ...state,
        addedUserList: state.addedUserList.map((userList, idx) =>
          idx === action.payload.stpIndex
            ? {
                ...userList,
                products: userList.products.map((product) =>
                  product.product_id === action.payload.product_id
                    ? {
                        ...product,
                        qty: state.isSecondaryOrder
                          ? Number(product.qty) + Number(action.payload.multiplier)
                          : Number(product.qty) + 1,
                      }
                    : product
                ),
              }
            : userList
        ),
      };
    }
    
    case 'DECREMENT_PRODUCT_QTY_OF_STP': {
      return {
        ...state,
        addedUserList: state.addedUserList.map((userList, idx) =>
          idx === action.payload.stpIndex
            ? {
                ...userList,
                products: userList.products.map((product) =>
                  product.product_id === action.payload.product_id
                    ? {
                        ...product,
                        qty: Math.max(
                          state.isSecondaryOrder
                            ? Number(product.qty) - Number(action.payload.multiplier)
                            : Number(product.qty) - 1,
                          0 
                        ),
                      }
                    : product
                ),
              }
            : userList
        ),
      };
    }
    
    case 'REMOVE_PRODUCT_QTY_OF_STP': {
      const arr = state.addedUserList[action.payload.stpIndex];
      const updatedProductsList = arr.products.filter(
        (prev) => prev.product_id !== action.payload.product_id,
      );
      arr.products = updatedProductsList;
      state.addedUserList[action.payload.stpIndex] = arr;

      return {
        ...state,
        addedUserList: state.addedUserList,
      };
    }
    case 'REPLACE_PRODUCT_QTY_OF_STP': {
      const index = state.addedUserList[
        action.payload.stpIndex
      ].products.findIndex(
        (prev) => prev.product_id === action.payload.productDetails.product_id,
      );
      const list = state.addedUserList[action.payload.stpIndex].products;

      list[index] = action.payload.productDetails;
      state.addedUserList[action.payload.stpIndex].products = list;
      return {
        ...state,
        cart: state.addedUserList,
      };
    }

    case 'INCREASE_PROD_QTY_FOR_STP': {
      let prodList = state?.stpProds || [];
      const index = prodList.findIndex(
        (vv) => vv.product_id === action.data.product_id,
      );
      prodList[index].quantity = Number(prodList[index].quantity) + 1;
      return { ...state, stpProds: prodList };
    }

    case 'DECREASE_PROD_QTY_FOR_STP': {
      let prodList = state?.stpProds || [];
      const index = prodList.findIndex(
        (vv) => vv.product_id === action.data.product_id,
      );
      if (Number(prodList[index].quantity) - 1 === 0) return state;
      else {
        prodList[index].quantity = Number(prodList[index].quantity) - 1;
        return { ...state, stpProds: prodList };
      }
    }

    case 'UPDATE_PROD_QTY_FOR_STP': {
      let prodList = state?.stpProds || [];
      const index = prodList.findIndex(
        (vv) => vv.product_id === action.data.product_id,
      );
      prodList[index].quantity = Number(action.data.enteredQty);
      return { ...state, stpProds: prodList };
    }

    case 'ADD_USER_TO_LIST': {
      const tempList = state?.addedUserList || [];

      return { ...state, addedUserList: [...tempList, action.data] };
    }
    case 'SET_USER_LIST': {
      return { ...state, addedUserList: action.data };
    }
    case 'REMOVE_USER_FROM_LIST': {
      const tempList = state?.addedUserList || [];

      const keys = (address = {}) => [
        address.delivery_district_name || '',
        address.delivery_company_pincode || '',
        address.delivery_location_name || '',
        address.delivery_address_line_1 || '',
        address.delivery_address_line_2 || '',
        address.delivery_address_line_3 || '',
      ];

      return {
        ...state,
        addedUserList: tempList.filter(
          (vv) => vv.company_id !== action.data.company_id,
        ),
        addedUserList: tempList.filter((vv) => {
          const vvAddressFields = keys(vv || {});
          const actionAddressFields = keys(action.data || {});

          const addressesMatch = vvAddressFields.every(
            (field, index) => field === actionAddressFields[index],
          );

          return !addressesMatch;
        }),
      };
    }
    case 'REMOVE_PROD_FROM_USER': {
      const { company_id, product_id } = action.data;
      const tempList = state?.addedUserList || [];

      // find the company and than filter the products
      const companyIndex = tempList.findIndex(
        (vv) => vv.company_id === company_id,
      );
      tempList[companyIndex].products = tempList[companyIndex].products.filter(
        (vv) => vv.product_id !== product_id,
      );

      return { ...state, addedUserList: tempList };
    }

    case 'INCREASE_PROD_QTY': {
      const { company_index, product_index } = action.data;

      const tempList = state?.addedUserList || [];
      tempList[company_index].products[product_index].quantity =
        Number(tempList[company_index].products[product_index].quantity) + 1;
      return { ...state, addedUserList: tempList };
    }

    case 'DECREASE_PROD_QTY': {
      const { company_index, product_index } = action.data;
      const tempList = state?.addedUserList || [];
      if (
        Number(tempList[company_index].products[product_index].quantity) - 1 ===
        0
      )
        return state;
      else {
        tempList[company_index].products[product_index].quantity =
          Number(tempList[company_index].products[product_index].quantity) - 1;
        return { ...state, addedUserList: tempList };
      }
    }

    case 'UPDATE_PROD_QTY_FOR_STP_IN_LIST': {
      const { company_index, product_index, enteredQty } = action.data;
      const tempList = state?.addedUserList || [];
      tempList[company_index].products[product_index].quantity = enteredQty;
      return { ...state, addedUserList: tempList };
    }

    // shiptoparty list
    case 'UPDATE_USER_TO_LIST': {
      const tempList = state?.addedUserList || [];

      const companyIndex = tempList.findIndex(
        (vv) => vv.company_id === action.data.company_id,
      );
      tempList[companyIndex] = action.data;
      return { ...state, addedUserList: tempList };
    }

    // ADD paint products to the USER
    case 'ADD_PAINT_PRODUCT_TO_USER': {
      const { selectedStp, prodObj } = action.data;

      console.log('selectedStp, prodObj', selectedStp, prodObj);
      const tempList = state?.addedUserList || [];

      const companyIndex = tempList.findIndex(
        (vv) => vv.company_id === selectedStp.company_id,
      );

      console.log('companyIndex', companyIndex);
      if (tempList[companyIndex].products) {
        tempList[companyIndex].products = [
          ...tempList[companyIndex]?.products,
          prodObj,
        ];
      } else {
        tempList[companyIndex].products = [prodObj];
      }

      return { ...state, addedUserList: tempList };
    }

    case 'SET_BOOKING_DETAILS': {
      return { ...state, booking_details: action.data };
    }
    case 'SET_EDIT_PO_BOOKING_DETAILS': {
      return { ...state, booking_editorder_details: action.data };
    }
    case 'ADD_USER_EDIT_PO_BOOKING_DETAILS': {
      return {
        ...state,
        booking_editorder_details: {
          ...state.booking_editorder_details,
          shipment_details: [
            ...state.booking_editorder_details.shipment_details,
            action.data,
          ],
        },
      };
    }
    case 'REMOVE_USER_EDIT_PO_BOOKING_DETAILS': {
      console.log('action.data', action.data);
      return {
        ...state,
        booking_editorder_details: {
          ...state.booking_editorder_details,
          shipment_details: [
            ...state.booking_editorder_details.shipment_details.map((item) => {
              if (
                item.ship_to_party_info.company_info.id ===
                action.data.ship_to_party_info.company_info.id
              )
                return {
                  ...item,
                  ship_to_party_info: {
                    ...item.ship_to_party_info,
                    operation_type: OperationType['DELETE'],
                  },
                };
              else return item;
            }),
          ],
        },
      };
    }
    case 'ADD_PRODUCT_EDIT_PO_BOOKING_DETAILS': {
      return {
        ...state,
        booking_editorder_details: {
          ...state.booking_editorder_details,
          shipment_details: state.booking_editorder_details.shipment_details.map((item) =>
            item.ship_to_party_info.company_info.id === action.data.ship_to_party_info.company_info.id &&
            item.ship_to_party_info.address_info.pincode === action.data.ship_to_party_info.address_info.pincode &&
            item.ship_to_party_info.address_info.address.address_line_1 === action.data.ship_to_party_info.address_info.address.address_line_1 &&
            item.ship_to_party_info.address_info.address.address_line_2 === action.data.ship_to_party_info.address_info.address.address_line_2 &&
            item.ship_to_party_info.address_info.address.address_line_3 === action.data.ship_to_party_info.address_info.address.address_line_3
              ? action.data
              : item
          ),
        },
      };
    }
    
    
    case 'UPDATE_PRODUCT_EDIT_PO_BOOKING_DETAILS': {
      return {
        ...state,
        booking_editorder_details: {
          ...state.booking_editorder_details,
          shipment_details: state.booking_editorder_details.shipment_details.map(
            (item) => item.ship_to_party_info.company_info.id === action.data.ship_to_party_info.company_info.id
              ? action.data
              : item
          ),
        },
      };
    }
    
    case 'UPDATE_USER_EDIT_PO_BOOKING_DETAILS': {
      return {
        ...state,
        booking_editorder_details: {
          ...state.booking_editorder_details,
          shipment_details: action.data,
        },
      };
    }
    default:
      return state;
  }
};

export default bcmOrderReducer;
